import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'

import { RootState } from 'redux/reducers/rootReducer'
import { SetTeamAction } from 'containers/account/store/actions'

import HeartMinion from 'assets/images/minions/HeartMinion.webp'
import CustomImage from 'components/custom-image/CustomImage'
import CustomButton from 'components/custom-button/CustomButton'
import { getClassNameForLanguage } from 'utils/common'
// eslint-disable-next-line max-len
import { updateFirstPaymentRedirectCompleted } from 'containers/welcome-page/service/welcome'

import './SuccessFirstPayment.scss'

const SuccessFirstPayment = () => {
    const { i18n, t } = useTranslation(['firstSuccessPayment'])
    const history = useHistory()
    const dispatch = useDispatch()
    const { settings } = useSelector(
        (state: RootState) => state.accountSettings,
    )

    const handleClick = async () => {
        if (settings) {
            dispatch(
                SetTeamAction({
                    settings: {
                        ...settings,
                        isFirstPaymentRedirectApplicable: false,
                    },
                }),
            )
        }
        await updateFirstPaymentRedirectCompleted()
        history.push('/')
    }

    return (
        <div className='container-success'>
            <div>
                <CustomImage className='image' src={HeartMinion} />
            </div>
            <h3
                className={`title-success ${getClassNameForLanguage({
                    i18n,
                    uk: 'uk-bold',
                    eng: 'eng-bold',
                })}`}
            >
                {t('firstSuccessPayment:thank_you')}
            </h3>
            <p
                className={`text-success ${getClassNameForLanguage({
                    i18n,
                    uk: 'uk-regular',
                    eng: 'eng-regular',
                })}`}
            >
                {t('firstSuccessPayment:thank_you_description')}
            </p>
            <div className='first-payment-button'>
                <CustomButton design='secondary' handleClick={handleClick}>
                    {t('firstSuccessPayment:continue')}
                </CustomButton>
            </div>
        </div>
    )
}

export default SuccessFirstPayment
